import _ from 'lodash';
import template from './dentalEditor.html';
import svg from 'svg.js';
import $ from 'jquery';
import { zubi } from './zubi.svg.js';

const veze = [
    { svgId: 'v_2827', id: 15, celjust: 'G' },
    { svgId: 'v_2726', id: 14, celjust: 'G' },
    { svgId: 'v_2625', id: 13, celjust: 'G' },
    { svgId: 'v_2524', id: 12, celjust: 'G' },
    { svgId: 'v_2423', id: 11, celjust: 'G' },
    { svgId: 'v_2322', id: 10, celjust: 'G' },
    { svgId: 'v_2221', id: 9, celjust: 'G' },
    { svgId: 'v_1121', id: 8, celjust: 'G' },
    { svgId: 'v_1211', id: 7, celjust: 'G' },
    { svgId: 'v_1312', id: 6, celjust: 'G' },
    { svgId: 'v_1413', id: 5, celjust: 'G' },
    { svgId: 'v_1514', id: 4, celjust: 'G' },
    { svgId: 'v_1615', id: 3, celjust: 'G' },
    { svgId: 'v_1716', id: 2, celjust: 'G' },
    { svgId: 'v_1817', id: 1, celjust: 'G' },
    { svgId: 'v_4847', id: 1, celjust: 'D' },
    { svgId: 'v_4746', id: 2, celjust: 'D' },
    { svgId: 'v_4645', id: 3, celjust: 'D' },
    { svgId: 'v_4544', id: 4, celjust: 'D' },
    { svgId: 'v_4443', id: 5, celjust: 'D' },
    { svgId: 'v_4342', id: 6, celjust: 'D' },
    { svgId: 'v_4241', id: 7, celjust: 'D' },
    { svgId: 'v_4131', id: 8, celjust: 'D' },
    { svgId: 'v_3231', id: 9, celjust: 'D' },
    { svgId: 'v_3332', id: 10, celjust: 'D' },
    { svgId: 'v_3433', id: 11, celjust: 'D' },
    { svgId: 'v_3534', id: 12, celjust: 'D' },
    { svgId: 'v_3635', id: 13, celjust: 'D' },
    { svgId: 'v_3736', id: 14, celjust: 'D' },
    { svgId: 'v_3837', id: 15, celjust: 'D' }
];

function mapVezu(id, celjust) {
    const index = _.findIndex(veze, v => v.id === id && v.celjust === celjust);
    if (index > -1) {
        return veze[index];
    }
    return null;
}

function editor($document, $timeout) {
    return {
        restrict: 'E',
        scope: {
            plan: '=',
            onClick: '&',
            onVeza: '&'
        },
        link: function(scope, iElement, attrs) {
            const q = $;

            const onClickHandler = id => {
                $timeout(() => {
                    scope.onClick({ id: id });
                });
            };

            function hideVeze() {
                veze.map(veza => {
                    const element = svg.get(veza.svgId);
                    element.hide();
                });
            }

            function setClickHandler(onClickHandler) {
                zubi.map(zub => {
                    const element = svg.get(zub.id);
                    element.click(() => {
                        onClickHandler(zub.id);
                    });
                });
            }

            function createBoundingBoxes() {
                zubi.map(zub => {
                    const element = svg.get(zub.id);
                    const bbox = drawBBox(element);
                    bbox.attr('id', `b${zub.id}`);
                    bbox.hide();
                });
            }

            function drawBBox(group) {
                const b = group.bbox();
                const bbox = group
                    .rect(b.width, b.height)
                    .addClass('box')
                    .move(b.x, b.y)
                    .style({ fill: 'none', 'stroke-width': 10, stroke: 'black' });
                return bbox;
            }

            function toggleSelected(zub) {
                const element = svg.get(`b${zub.id}`);
                element.hide();
                if (zub.selected === true) {
                    element.show();
                }
            }

            function toggleFilled(zub) {
                const element = svg.get(zub.id);
                element.children().map(c => {
                    if (c.type === 'path') {
                        c.style({ fill: '#fafafa' });
                        if (zub.filled === true) {
                            c.style({ fill: '#fff539' });
                        }
                    }
                });
            }

            function toggleVeze(veza) {
                const element = svg.get(veza.svgId);
                element.hide();
                if (veza.active === true) {
                    element.show();
                }
            }

            scope.$on('$destroy', () => {
                zubi.map(zub => {
                    const element = svg.get(zub.id);
                    element.off();
                });
            });

            // hideVeze();
            setClickHandler(onClickHandler);
            createBoundingBoxes();

            scope.$watch('plan', (newVal, oldVal) => {
                if (newVal && newVal.pozicije) {
                    newVal.pozicije.map(zub => {
                        toggleSelected(zub);
                        toggleFilled(zub);
                    });
                }

                if (newVal && newVal.veze) {
                    newVal.veze.map(v => {
                        const veza = mapVezu(v.id, v.celjust);
                        if (veza !== null) {
                            veza.active = v.active;
                            toggleVeze(veza);
                        }
                    });
                }
            });
        },
        templateUrl: template
    };
}

editor.$inject = ['$document', '$timeout'];

export { editor };



// WEBPACK FOOTER //
// ./app/components/radniNalog/dentalEditor.directive.js